// components/Header/index.js

'use client'
import { Flex } from 'antd';
import HeaderBar from './headerBar';
import './header.scss';

export default function IndustrialBeltHeader() {

    return (
        <header className="page_header">
            <div className='page_header_bx'>
                <Flex align='center' justify='space-between'>
                    <div className='header_logo_bx' onClick={() => window.open('/')}>
                        <img src="https://public-read-bkt-oss.oss-cn-hangzhou.aliyuncs.com/PC/yiwuTrade/shop/logo_regio.png" alt="logo" className='header_logo_region'/>
                    </div>
                    <HeaderBar />
                </Flex>
            </div>
        </header>
    );
}